import { Template } from "core/types/index";
import { parseAsString, useQueryState } from "nuqs";
import { useCallback, useMemo } from "react";
import { useTemplates } from "./useTemplates";

export const useSelectedTemplate = <T extends Template | null>() => {
  const [_template, _setSelectedTemplate] = useQueryState(
    "template",
    parseAsString,
  );

  const { data: templates } = useTemplates();

  const template = useMemo(() => {
    return (
      templates.find((i) => i.name + i.defaultLength === _template) ?? null
    );
  }, [_template, templates]);

  const setSelectedTemplate = useCallback(
    (nextTemplate: T) => {
      if (!nextTemplate) {
        return _setSelectedTemplate(null);
      }
      return _setSelectedTemplate(
        // @TODO: For NL we duplicate existing revisit template and add another time label to it
        // @TODO: It would be awesome to move it to database layer.
        nextTemplate.name + nextTemplate.defaultLength,
      );
    },
    [_setSelectedTemplate],
  );

  return [template, setSelectedTemplate] as const;
};
